(() => {
  const initialized = new WeakSet();
  const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const initialize = root => {
    if (initialized.has(root)) return;
    initialized.add(root);
    const form = root.querySelector('[data-mm-help-form]');
    const input = root.querySelector('[data-mm-help-input]');
    const panel = root.querySelector('[data-mm-help-results]');
    const status = root.querySelector('[data-mm-help-status]');
    const items = [...root.querySelectorAll('[data-mm-help-item]')];
    const terms = items.map(item => normalize(item.dataset.mmHelpText));
    const links = () => items.filter(item => !item.hidden).map(item => item.querySelector('a')).filter(Boolean);
    const emptyContact = root.querySelector('[data-mm-help-empty-contact]');
    const stopWords = new Set(['where', 'is', 'are', 'my', 'the', 'a', 'an', 'how', 'do', 'does', 'i', 'can', 'could', 'you', 'please', 'to', 'for', 'with', 'me', 'help', 'has', 'it']);
    const render = () => {
      panel.hidden = false;
      const query = normalize(input.value);
      const intent = query.replace(/where (?:is|are) (?:my |the )?(?:order|parcel|package)\b/g, 'tracking').replace(/not sure where to start|which (?:product|format) (?:should i choose|is right for me)|what (?:product|format) (?:should i choose|is right for me)/g, 'finder').replace(/has (?:not|nt) arrived|not arrived|hasn t arrived/g, 'tracking');
      const words = intent.split(' ').filter(word => word && !stopWords.has(word));
      let count = 0;
      items.forEach((item, index) => {
        const matches = words.length > 0 && words.every(word => terms[index].includes(word));
        item.hidden = !matches;
        if (matches) count++;
      });
      if (emptyContact) emptyContact.hidden = !query || count > 0;
      status.textContent = !query ? root.dataset.empty : count ? root.dataset.found.replace('__COUNT__', String(count)) : root.dataset.noResults;
    };
    input.disabled = false;
    root.querySelectorAll('[data-mm-help-query], [data-mm-help-submit]').forEach(button => button.disabled = false);
    input.addEventListener('input', render);
    input.addEventListener('focus', () => { if (panel.hidden) render(); });
    form.addEventListener('submit', event => { event.preventDefault(); render(); links()[0]?.focus(); });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape' && (form.contains(event.target) || panel.contains(event.target))) {
        event.preventDefault();
        input.value = '';
        input.focus();
        panel.hidden = true;
        items.forEach(item => item.hidden = true);
        status.textContent = '';
        if (emptyContact) emptyContact.hidden = true;
      }
      if (event.key === 'ArrowDown' && event.target === input) {
        render();
        const first = links()[0];
        if (first) { event.preventDefault(); first.focus(); }
      }
    });
    root.querySelectorAll('[data-mm-help-query]').forEach(button => button.addEventListener('click', () => {
      input.value = button.dataset.mmHelpQuery;
      input.focus();
      render();
    }));
    const nav = root.querySelector('.mm-help-nav');
    nav?.addEventListener('focusin', event => {
      if (!window.matchMedia('(max-width: 1000px)').matches) return;
      const bounds = nav.getBoundingClientRect();
      const item = event.target.getBoundingClientRect();
      if (item.left < bounds.left) nav.scrollLeft += item.left - bounds.left - 4;
      else if (item.right > bounds.right) nav.scrollLeft += item.right - bounds.right + 4;
    });
  };
  const scan = scope => scope.querySelectorAll('[data-mm-help]').forEach(initialize);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
